<div class="phone-upload" [class.phone-upload--compact]="compact" role="region" aria-label="Upload from your phone">
  <h4 class="phone-upload__title">Upload from phone</h4>

  <div class="phone-upload__code">
    <img *ngIf="state === 'waiting' && qrDataUrl" [src]="qrDataUrl" width="240" height="240"
         alt="QR code that opens the phone upload page">
    <div *ngIf="state === 'starting'" class="phone-upload__placeholder phone-upload__placeholder--loading" aria-hidden="true"></div>
    <div *ngIf="state === 'received'" class="phone-upload__placeholder phone-upload__placeholder--done" aria-hidden="true">
      <i class="fa-solid fa-circle-check"></i>
    </div>
  </div>

  <p class="phone-upload__status" aria-live="polite">{{ statusText }}</p>
</div>
